var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingCase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1703_3696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.05 53.12C79.01 42.77 69.92 35 59 35C50.33 35 42.8 39.92 39.05 47.12C30.02 48.08 23 55.73 23 65C23 74.93 31.07 83 41 83H80C88.28 83 95 76.28 95 68C95 60.08 88.85 53.66 81.05 53.12ZM74 62L59 77L44 62H53V50H65V62H74Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1703_3696",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1703_3696"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1703_3696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1703_3696",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCase1);
export default __webpack_public_path__ + "static/media/MarketingCase1.77d0d3fb24e276e5828e8f066aaba1cc.svg";
export { ForwardRef as ReactComponent };